import { Box } from "@mui/material";
import { NAVBAR_HEIGHT } from "../../../pages/Map";
import QuickMenu from "../../onboarding/QuickMenu";
import Advisory, { ADVISORY_PREFERENCE_KEY } from "../../onboarding/Advisory";
import { useMemo, useState } from "react";
import { useConfig } from "../../../contexts/ConfigContext";

export default function StartupModal() {
  const config = useConfig();
  const [showQuickMenu, setShowQuickMenu] = useState(false);

  const shouldShowAdvisory = useMemo(() => {
    return JSON.parse(localStorage.getItem(ADVISORY_PREFERENCE_KEY) || "true");
  }, []);

  function handleAcknowledged() {
    setShowQuickMenu(true);
  }

  const opacity = Math.round((config.backgroundOpacity || 0.4) * 255)
    .toString(16)
    .padStart(2, "0");

  return (
    <Box
      sx={{
        height: "100%",
        maxHeight: `calc(100dvh - ${NAVBAR_HEIGHT})`,
        position: "fixed",
        width: "100%",
        marginTop: NAVBAR_HEIGHT,
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
        // backdrop layer
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: (theme) => `${theme.palette.secondary.main}${opacity}`,
          zIndex: -1
        }
      }}
      tabIndex={0}
    >
      {showQuickMenu || !shouldShowAdvisory ? <QuickMenu /> : <Advisory onAcknowledge={handleAcknowledged} />}
    </Box>
  );
}
